"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var getConfig_1 = require("../config/getConfig");
var getElement_1 = require("./getElement");
var getSimpleValue_1 = require("./getSimpleValue");
var getSchemaValue_1 = require("./getSchemaValue");
var getArrayValue_1 = require("./getArrayValue");
function getValue(_a, inputConfig) {
    var $ = _a.$, el = _a.el;
    var config = getConfig_1["default"]({ $: $, el: el }, inputConfig);
    var element = getElement_1["default"]({ $: $, el: el }, config);
    var type = config.type, selector = config.selector, condition = config.condition, exist = config.exist, rest = __rest(config, ["type", "selector", "condition", "exist"]);
    var schema = rest.schema;
    if (exist) {
        return $(selector).length > 0;
    }
    if (condition && !condition($(el))) {
        return null;
    }
    if (type === 'array') {
        return getArrayValue_1["default"]({ $: $, el: element }, rest);
    }
    else if (schema) {
        var currentSchema = getConfig_1["default"]({ $: $, el: el }, schema);
        return getSchemaValue_1["default"]({ $: $, el: element }, currentSchema);
    }
    else {
        return getSimpleValue_1["default"]({ $: $, el: element }, rest);
    }
}
exports["default"] = getValue;
